import * as React from 'react'
import { connect } from 'react-redux'
import { Main as FormMain } from './forms/main'
import { ThankYou } from './forms/thankyou'
import {
  LoadableAnswersMain,
  LoadableArticleList,
  LoadableDetails,
  LoadableEmailTranscript,
  LoadableOnlineInCall,
  LoadableOnlineMain,
  LoadableSearchResults
} from './main-loadables'
import { Route } from './route'
import { Notification } from './notification/notification'
import { RootState } from '../types/rootstate'
import { Branding } from './branding'

import '../sass/main.scss'
import '../sass/dropzone.scss'
import '../sass/transitions.scss'
import { resizingComponent } from './resizingcomponent'
import { Announcer } from './a11y/announcer'

declare global {
  interface Window {
    xprops
    xchild
  }
}

interface StateProps {
  notification: RootState['notification']
  isWidgetOpen: RootState['widget']['isOpen']
  hubItems: RootState['hub']
  inTransition: RootState['widget']['inTransition']
}

interface DispatchProps {}

interface OwnProps {}

type MainProps = StateProps & DispatchProps & OwnProps

function mapStateToProps(state: RootState): StateProps {
  return {
    notification: state.notification,
    isWidgetOpen: state.widget.isOpen,
    hubItems: state.hub,
    inTransition: state.widget.inTransition
  }
}

function mapDispatchToProps(dispatch): DispatchProps {
  return {}
}

interface MainState {}

class MainComponent extends React.Component<MainProps, MainState> {
  references: {
    container: HTMLDivElement
  } = {
    container: null
  }

  componentDidMount() {
    resizingComponent.dimensionsUpdated(0, -0.1)
  }

  render() {
    const showNotification = this.props.notification.isOpen
    const showWidget =
      this.props.isWidgetOpen && !this.props.notification.isOpen

    const styles: any = {}
    if (this.props.inTransition) {
      styles.visibility = 'hidden'
    }

    return (
      <div style={styles}>
        <div className='imbox resizing-root'>
          <Announcer>
            {showNotification && <Notification />}

            {showWidget && (
              <>
                <Branding />
                <Route path='answers' component={LoadableAnswersMain} />
                {/* <Route path='notification' component={Notification} /> */}
                <Route
                  path='answersArticleList'
                  component={LoadableArticleList}
                />
                <Route
                  path='answersArticleDetails'
                  component={LoadableDetails}
                />
                <Route
                  path='answersSearchResults'
                  component={LoadableSearchResults}
                />
                <Route path='online' component={LoadableOnlineMain} />
                <Route
                  path='onlineEmailTranscript'
                  component={LoadableEmailTranscript}
                />
                <Route path='onlineInCall' component={LoadableOnlineInCall} />
                <Route path='form' component={FormMain} />
                <Route path='formThankYou' component={ThankYou} />
                <Route path='preChatForm' component={FormMain} />
              </>
            )}
          </Announcer>
        </div>
      </div>
    )
  }
}

const Main = connect<StateProps, DispatchProps, OwnProps>(
  mapStateToProps,
  mapDispatchToProps
)(MainComponent)

export { Main }
